import * as React from 'react';
import * as styles from './Main.css';
export const Main = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['main']}>{props.children}</div>;
};
